import React from 'react';
import { DayMap } from '@/types';
import { useHooks } from '@/components/templates/MonthlyChart/hooks';

export interface MonthlyChartProps {
  dayMap: DayMap;
}

const MonthlyChart: React.FC<MonthlyChartProps> = (props) => {
  const { chartItems } = useHooks(props);

  if (chartItems.length === 0) {
    return (
      <div className="glass-panel p-12 flex flex-col items-center justify-center text-center animate-fade-in delay-100">
        <svg
          className="h-12 w-12 text-foreground/25 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 002 2h2a2 2 0 002-2"
          />
        </svg>
        <h3 className="text-lg font-display font-medium text-foreground/80">
          No Monthly Data
        </h3>
        <p className="text-xs text-foreground/40 font-mono mt-1 uppercase tracking-wider">
          Import timelogs to generate monthly tracking charts
        </p>
      </div>
    );
  }

  return (
    <div className="glass-panel p-6 space-y-4 animate-fade-in delay-100">
      <div>
        <h3 className="text-sm font-mono uppercase tracking-wider text-foreground/60 font-semibold">
          Monthly Hours Breakdown
        </h3>
        <p className="text-[10px] text-foreground/40 font-mono mt-0.5">
          AGGREGATED BY CALENDAR MONTHS
        </p>
      </div>
      
      <div className="space-y-4 pt-2">
        {chartItems.map((item) => (
          <div key={item.monthKey} className="space-y-1.5">
            <div className="flex justify-between items-center text-xs font-mono">
              <span className="text-foreground/75 font-semibold">{item.label}</span>
              <span className="text-accent font-bold num-mono">{item.displayHours}</span>
            </div>
            
            <div className="h-6 w-full bg-foreground/[0.01] border border-card-border rounded overflow-hidden relative">
              <div
                className="h-full bg-accent/15 border-r-2 border-accent transition-all duration-1000 ease-out"
                style={{ width: `${item.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthlyChart;
